export default class PageArchiveDocumentation {
	constructor() {

		const yearSelect = document.getElementById('year_filter');

		if (yearSelect) {
			yearSelect.addEventListener('change', function() {
				const selectedYear = this.value;
				const currentUrl = new URL(window.location.href);
				if (selectedYear) {
					currentUrl.searchParams.set('f_year', selectedYear);
				} else {
					currentUrl.searchParams.delete('f_year');
				}
				window.location.href = currentUrl.toString();
			});
		}

	}
}
